export function updateEmail(newEmail: string, user: string | undefined) {
  if (user) {
    const formData = new FormData();
    formData.set("newMail", newEmail);
    return fetch(`/api/user/${user}/updateMailAddress`, {
      method: "PUT",
      body: formData,
    });
  } else {
    return Promise.reject("require user");
  }
}
